import { Component } from '@angular/core';
import { MediaBankFileModel } from '../media-bank-file.model';
import { ItemViewContainerBase } from '@fi-app/core/item-view-container-base';

@Component({
    selector: 'fi-media-bank-view-container',
    template: `
        <fi-media-bank-view [mediaBankFile]="mediaBankFile" [isFromMediaBankModalDialog]="isFromMediaBankModalDialog">
        </fi-media-bank-view>
    `,
    styleUrls: ['./media-bank-view-container.component.scss'],
    standalone: false,
})
export class MediaBankViewContainerComponent extends ItemViewContainerBase {
    mediaBankFile: MediaBankFileModel;
    isFromMediaBankModalDialog: boolean = false;
}
